import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { ResourcesContext } from '../../ResourcesContext';
import { GlobalContext } from '../../../../../contexts/GlobalContext';
import { useToasts } from '../../../../../common/Toast';
import { useDialog } from '../../../../../common/Dialog';
import useLocalStorage from '../../../../../hooks/useLocalStorage';
import { APIWebhook } from '../../../../../../../../../typings/Webhook.interface';
import { APIDestination } from '../../../../../../../../../typings/Destination.interface';
import { APISource } from '../../../../../../../../../typings/Source.interface';
const configs = {
  webhooks: 'connection',
  destinations: 'destination',
  sources: 'source'
} as const;
const useOnDisableToggle = (type, mutate) => {
  const $ = _c(10);
  const {
    mutateResourceType
  } = useContext(ResourcesContext);
  const {
    addToast
  } = useToasts();
  const showDialog = useDialog();
  const label = configs[type];
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const [confirm_disable, setConfirmDisable] = useLocalStorage(`pref:prompt_archive_${type}`, true);
  let t0;
  if ($[0] !== HookdeckAPI || $[1] !== addToast || $[2] !== confirm_disable || $[3] !== label || $[4] !== mutate || $[5] !== mutateResourceType || $[6] !== setConfirmDisable || $[7] !== showDialog || $[8] !== type) {
    t0 = (resource, disable) => {
      const apply = () => {
        const promise = disable ? HookdeckAPI[type].disable(resource.id) : HookdeckAPI[type].enable(resource.id);
        return promise.then(resource_0 => {
          addToast("success", `${resource_0.disabled_at ? "Disabled" : "Enabled"} ${label} ${"full_name" in resource_0 ? resource_0.full_name : resource_0.name}`);
          mutateResourceType?.(type, resource_0);
          mutate?.();
        }).catch(() => {
          addToast("error", `Failed to ${disable ? "disable" : "enable"} ${label} ${"full_name" in resource ? resource.full_name : resource.name}`);
        });
      };
      if (disable && confirm_disable) {
        showDialog(() => {
          apply();
          setConfirmDisable(false);
        }, _temp, {
          message: `By disabling the ${label} it will no longer accept and deliver events, are you sure?`
        });
      } else {
        apply();
      }
    };
    $[0] = HookdeckAPI;
    $[1] = addToast;
    $[2] = confirm_disable;
    $[3] = label;
    $[4] = mutate;
    $[5] = mutateResourceType;
    $[6] = setConfirmDisable;
    $[7] = showDialog;
    $[8] = type;
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  const onToggleDisable = t0;
  return onToggleDisable;
};
export default useOnDisableToggle;
function _temp() {
  return null;
}